import * as React from "react"
import { Link } from "gatsby"
import CartIcon from "../icons/cart"
import { cartButton, badge } from "./cart-button.module.css"

export function CartButton({ quantity }) {
  return (
    <Link
      aria-label={`Shopping Cart with ${quantity} items`}
      to="/cart"
      className={cartButton}
      className="hover:bg-pink-600 pt-1 border-r-2 border-black flex px-3 justify-end"
    >
      <p className="font-bold text-black">CART</p>
      {quantity > 0 && <p className="text-white font-bold"> ({quantity})</p>}
    </Link>
  )
}
